/**
 * @packageDocumentation
 * @module HackerAPI.File
 */
import { __extends } from "tslib";
import Base from "../base/base";
import Type from "./type/type";
import HackerAPIFetch from "../hackerapi-fetch/hackerapi-fetch";
import { parseDate } from "../utils/utils";
/**
 * A data container for file data
 * @class
 * @extends { HackerAPI.Base }
 */
var File = /** @class */ (function (_super) {
    __extends(File, _super);
    /**
     * Creates a new instance of a file
     * @constructor
     * @param file
     */
    function File(_a) {
        var id = _a.id, name = _a.name, type = _a.type, size = _a.size, user_id = _a.user_id, userId = _a.userId, user_name = _a.user_name, userName = _a.userName, expiry = _a.expiry, url = _a.url, mime_type = _a.mime_type, mimeType = _a.mimeType, event_slug = _a.event_slug, eventSlug = _a.eventSlug, created_at = _a.created_at, createdAt = _a.createdAt, updated_at = _a.updated_at, updatedAt = _a.updatedAt;
        var _this = _super.call(this) || this;
        /**
         * @type { number }
         */
        _this.id = id;
        /**
         * @type { string }
         */
        _this.name = name;
        /**
         * @type { HackerAPI.File.Type | string }
         */
        _this.type = type;
        /**
         * File size in bytes
         * @returns
         */
        _this.size = size;
        /**
         * @returns
         */
        _this.userId = user_id || userId;
        /**
         * @returns
         */
        _this.userName = user_name || userName;
        /**
         * When the url expires
         * @returns
         */
        _this.expiry = parseDate(expiry);
        /**
         * @type { string }
         */
        _this.url = url;
        /**
         * @type { string }
         */
        _this.mimeType = mime_type || mimeType;
        /**
         * @type { string }
         */
        _this.eventSlug = event_slug || eventSlug;
        /**
         * @returns
         */
        _this.createdAt = parseDate(created_at || createdAt);
        /**
         * @returns
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    Object.defineProperty(File, "Type", {
        /**
         * @returns
         */
        get: function () {
            return Type;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Fetches info about a file
     * @param file
     * @param [token]
     * @returns
     */
    File.fetch = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/files/" + id,
            method: "GET",
            token: token
        }).then(function (data) { return new File(data); });
    };
    /**
     * Downloads a file
     * @param file
     * @param [token]
     * @returns
     */
    File.download = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/files/" + id + "/download",
            method: "GET",
            token: token
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        });
    };
    /**
     * Fetches all the files belonging to a user, applying the appropriate filters
     * @param user
     * @param user.id
     * @param [type]
     * @param [event]
     * @param event.slug
     * @param [token]
     * @returns
     */
    File.fetchAllByUserId = function (_a, type, _b, token) {
        var id = _a.id;
        if (type === void 0) { type = null; }
        var slug = _b.slug;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var params = {};
        if (type) {
            params.type = type;
        }
        if (slug) {
            params.event = slug;
        }
        return HackerAPIFetch({
            path: "/v2/users/" + id + "/files",
            method: "GET",
            token: token,
            params: params
        }).then(function (data) { return data.map(function (datum) { return new File(datum); }); });
    };
    return File;
}(Base));
export default File;
//# sourceMappingURL=file.js.map